export function generateColor() {
  var c = '';
  while (c.length < 6) {
    c += (Math.random()).toString(16).substr(-6).substr(-1)
  }
  return '#' + c;
  // return Math.floor(Math.random() * 16777215).toString(16);
}
